<template lang="jade">
  div.Spinner(class="animated" v-bind:class="spinner" v-show="loading" transition="fade")
    div.Spinner__icon
    div.Spinner__text(name="spinner::text") loading...
  slot(v-if="!loading" name="content")
</template>

<script>
export default {
  data () {
    return {
      load: 0
    }
  },
  props: {
    position: {
      type: String,
      default: 'center'
    },
    type: {
      type: String,
      default: 'fullscreen'
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    spinner () {

    }
  },
  events: {
    'loading::spinner' (options) {
      this.$set('loading', true)
      this.$set('load', 25)
    },
    'complete::spinner' () {
      this.$set('loading', false)
    },
    'ajax::spinner' (progress) {
      // faked load TODO refactor to calculate correct load percentage
      this.$set('load', 50)
    }
  },
  methods: {},
  components: {}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// spinner.vue?b69f3e84